import React from 'react';
import { Lightbulb, BatteryCharging, Wrench, Building2, Home, AlertTriangle } from 'lucide-react';
const services = [{
  title: 'Panel Upgrades',
  description: "Modernize your electrical system to handle today's power demands safely and efficiently.",
  icon: Wrench
}, {
  title: 'Lighting Installation',
  description: 'Custom indoor, outdoor, and landscape lighting design and installation.',
  icon: Lightbulb
}, {
  title: 'EV Chargers',
  description: 'Professional installation of Level 2 electric vehicle charging stations for your home or business.',
  icon: BatteryCharging
}, {
  title: 'Commercial Wiring',
  description: 'Comprehensive electrical solutions for retail, office, and industrial spaces.',
  icon: Building2
}, {
  title: 'Residential Service',
  description: 'From troubleshooting outlets to complete home rewiring, we handle all residential needs.',
  icon: Home
}, {
  title: 'Emergency Service',
  description: 'Fast, reliable response for critical electrical issues when you need help immediately.',
  icon: AlertTriangle
}];
export function Services() {
  return <section id="services" className="py-24 bg-zinc-900 relative" data-id="element-130">
      <div className="container mx-auto px-6 md:px-12" data-id="element-131">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-132">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-133">
            <div className="h-[2px] w-8 bg-red-600" data-id="element-134"></div>
            <span className="text-yellow-600 font-bold tracking-widest uppercase text-sm" data-id="element-135">
              Our Expertise
            </span>
            <div className="h-[2px] w-8 bg-red-600" data-id="element-136"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mb-6" data-id="element-137">
            Comprehensive Electrical Solutions
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-138">
            We deliver top-tier electrical services with a commitment to safety,
            quality, and code compliance for every project, large or small.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-139">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="bg-zinc-950 p-8 rounded-sm border border-zinc-800 hover:border-red-600/50 transition-colors group" data-id="element-140">
                <div className="bg-zinc-900 w-16 h-16 flex items-center justify-center rounded-sm mb-6 group-hover:bg-red-600/10 transition-colors" data-id="element-141">
                  <Icon className="w-8 h-8 text-yellow-600 group-hover:text-red-500 transition-colors" data-id="element-142" />
                </div>
                <h3 className="text-2xl font-black uppercase tracking-tight text-white mb-4" data-id="element-143">
                  {service.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed" data-id="element-144">
                  {service.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-145">
          <p className="text-zinc-300 font-medium mb-6" data-id="element-146">
            Don't see what you need? We probably do it.
          </p>
          <a href="tel:847-555-0198" className="inline-flex items-center gap-2 text-yellow-600 hover:text-yellow-500 font-bold uppercase tracking-widest border-b-2 border-yellow-600 hover:border-yellow-500 pb-1 transition-colors" data-id="element-147">
            Contact us to discuss your project
          </a>
        </div>
      </div>
    </section>;
}